<template>
  <div class="index">
    <div class="banner">
      <img class="logo" src="../../static/img/logo.png" />
      <h5><span>|</span> 会员管理系统</h5>
      <div id="qrcode"></div>
      <div class="user_msg">
        <p class="warn_word" v-show="show">
          <span></span> 您有一条新的通知，请及时处理
        </p>
        <a @click="to_msg" class="warn"
          ><span class="dian" v-show="show"></span>提醒</a
        >
        <img src="../../static/img/icon1.png" />
        <div>
          <strong>{{ name }}</strong>
          <p>
            会员编号：<span>{{ bh }}</span>
          </p>
        </div>
        <span class="out" @click="out">退出</span>
      </div>
    </div>
    <div class="center">
      <div class="shade" v-show="tc">
        <div class="tc">
          <p class="tc_tit">
            提示 <span class="closed" @click="cancel"></span>
          </p>
          <p>您有资料需要去完善，请去完善</p>
          <div>
            <span class="no" @click="cancel">取消</span>
            <span class="to_wanshan" @click="to_wanshan">好的</span>
          </div>
        </div>
      </div>
      <div class="center_box">
        <ul class="nav">
          <li
            v-for="(item, index) in navList"
            :class="index == isActive ? 'blue' : ''"
            @click="tabNav(index)"
            v-show="item.isShow"
          >
            {{ item.name }}
          </li>
          <div class="img_box">
            <img src="../../static/img/icon19.png" />
          </div>
        </ul>
        <div class="con">
          <home
            @changePageType="changePageType"
            :pageType="pageType"
            :show-home="showHome"
            v-if="isActive == 0"
          ></home>
          <huifei :show-huifei="showHuifei" v-if="isActive == 1"></huifei>
          <fapiao :show-fapiao="showFapiao" v-if="isActive == 2"></fapiao>

          <xinxi :show-xinxi="showXinxi" v-if="isActive == 3"></xinxi>
          <xinxi2 :show-xinxi2="showXinxi2" v-if="isActive == 4"></xinxi2>
          <guanli :show-guanli="showGuanli" v-if="isActive == 5"></guanli>

          <wanshan :show-wanshan="showWanshan" v-if="isActive == 6"></wanshan>
          <contribute
            :show-contribute="showContribute"
            v-if="isActive == 7"
          ></contribute>
          <mima :show-mima="showMima" v-if="isActive == 8"></mima>

          <msg ref="get_msg" :showMsg="showMsg" v-if="isActive == -1"></msg>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import { Message, MessageBox } from 'element-ui'
import QRCode from 'qrcodejs2'
import home from './Home'
import huifei from './Huifei'
import fapiao from './Fapiao'
import guanli from './Guanli'
import xinxi from './Xinxi'
import xinxi2 from './Xinxi1'
import mima from './Mima'
import wanshan from './Wanshan'
import msg from './Msg'
import contribute from './Contribute'
import bottom from './Bottom'
import Qs from 'qs'
export default {
  components: {
    home,
    huifei,
    fapiao,
    guanli,
    xinxi,
    xinxi2,
    mima,
    wanshan,
    contribute,
    msg,
    bottom
  },
  data () {
    return {
      pageType: 1,
      tc: false,
      showHome: true,
      showHuifei: true,
      showFapiao: true,
      showGuanli: true,
      showXinxi: true,
      showXinxi2: true,
      showMima: true,
      showContribute: true,
      showWanshan: true,
      showMsg: true,
      isActive: 0,
      name: '',
      bh: '',
      show: false,
      navList: [{
        name: '会员首页',
        isShow: true
      },
      {
        name: '缴纳会费',
        isShow: true
      },
      {
        name: '申请会费票据',
        isShow: true
      },

      {
        name: '重要信息变更',
        isShow: true
      },

      {
        name: '信息变更',
        isShow: false
      },

      {
        name: '其他联系人管理',
        isShow: true
      },

      {
        name: '完善理事资料',
        isShow: false
      },
      {
        name: '企业投稿',
        isShow: false
      },
      {
        name: '修改密码',
        isShow: true
      }
      ]
    };
  },
  created () { },
  updated () {
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    var data1 = {
      'access-token': token
    };
    this.$axios({
      method: 'post',
      url: 'newsmessage/ifnotread',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 1) {
        this.show = true;
      } else {
        this.show = false;
      }
    });
  },
  mounted () {
    if (sessionStorage.getItem('name')) {
      this.name = sessionStorage.getItem('name');
    };
    if (sessionStorage.getItem('bh')) {
      this.bh = sessionStorage.getItem('bh');
    };
    if (Number(sessionStorage.getItem('type')) == 2) {
      this.qrcode();
    };
    if (sessionStorage.getItem('isActive')) {
      this.isActive = sessionStorage.getItem('isActive');
    };
    if (sessionStorage.getItem('Token')) {
      var token = sessionStorage.getItem('Token');
    };
    if (sessionStorage.getItem('type')) {
      switch (Number(sessionStorage.getItem('type'))) {
        case 2:
          this.navList[7].isShow = true;
          //企业用户判断理事类型
          switch (Number(sessionStorage.getItem('zhiwei'))) {
            case 0:
              break;
            case 1:
              this.navList[6].isShow = true;
              //理事
              if (Number(sessionStorage.getItem('ziliao')) == 1) {
                //资料未完善  弹窗提示
                if (!sessionStorage.getItem('tc')) {
                  sessionStorage.setItem('tc', 1);
                  this.tc = true;
                }
              }
              break;
            case 2:
              //常务理事								
              this.navList[6].isShow = true;
              if (Number(sessionStorage.getItem('ziliao')) == 1) {
                //资料未完善  弹窗提示
                if (!sessionStorage.getItem('tc')) {
                  sessionStorage.setItem('tc', 1);
                  this.tc = true;
                }
              }
              break;
            //副会长
            case 3:
              this.navList[6].isShow = true;
              if (Number(sessionStorage.getItem('ziliao')) == 1) {
                //资料未完善  弹窗提示
                if (!sessionStorage.getItem('tc')) {
                  sessionStorage.setItem('tc', 1);
                  this.tc = true;
                }
              } else if (Number(sessionStorage.getItem('ziliao')) == 3) {
                //任免未完善  弹窗提示
                if (!sessionStorage.getItem('tc')) {
                  sessionStorage.setItem('tc', 1);
                  this.tc = true;
                }
              } else if (Number(sessionStorage.getItem('ziliao')) == 4) {
                //登记表未完善
                if (!sessionStorage.getItem('tc')) {
                  sessionStorage.setItem('tc', 1);
                  this.tc = true;
                }
              }
              break;
          };
          break;
        case 3:
          //个人用户

          this.navList[2].isShow = false;
          this.navList[3].isShow = false;
          this.navList[4].isShow = true;
          this.navList[5].isShow = false;
          break;
        case 4:
          //特邀 常务理事
          this.navList[0].isShow = false;
          this.navList[1].isShow = false;
          this.navList[2].isShow = false;
          this.navList[3].isShow = false;
          this.navList[5].isShow = false;
          this.navList[6].isShow = true;
          this.navList[8].isShow = false;

          if (Number(sessionStorage.getItem('ziliao')) == 1) {
            //资料未完善  弹窗提示
            if (!sessionStorage.getItem('tc')) {
              sessionStorage.setItem('tc', 1);
              this.tc = true;
            }
          }
          break;
        case 5:
          //特邀 副会长
          this.navList[0].isShow = false;
          this.navList[1].isShow = false;
          this.navList[2].isShow = false;
          this.navList[3].isShow = false;
          this.navList[5].isShow = false;
          this.navList[6].isShow = true;
          this.navList[8].isShow = false;
          if (Number(sessionStorage.getItem('ziliao')) == 1) {
            //资料未完善  弹窗提示
            if (!sessionStorage.getItem('tc')) {
              sessionStorage.setItem('tc', 1);
              this.tc = true;
            }
          } else if (Number(sessionStorage.getItem('ziliao')) == 3) {
            //任免未完善  弹窗提示
            if (!sessionStorage.getItem('tc')) {
              sessionStorage.setItem('tc', 1);
              this.tc = true;
            }
          } else if (Number(sessionStorage.getItem('ziliao')) == 4) {
            //登记表未完善
            if (!sessionStorage.getItem('tc')) {
              sessionStorage.setItem('tc', 1);
              this.tc = true;
            }
          }
          break;
      }
    };
    var data1 = {
      'access-token': token
    };

    this.$axios({
      method: 'post',
      url: 'company/memberstatus',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 3) {
        if (response.data.result.PaymentValidNow == '冻结' || response.data.result.PaymentValidNow == '已退会') {
          this.navList[0].isShow = true;
          this.navList[1].isShow = true;
          this.navList[2].isShow = true;
          this.navList[3].isShow = true;
          this.navList[4].isShow = false;
          this.navList[5].isShow = true;
          this.navList[6].isShow = false;
          this.navList[7].isShow = false;
          this.navList[8].isShow = true;
        }
      } else if (response.data.state == 4) {
        if (response.data.result.PaymentValidNow == '冻结' || response.data.result.PaymentValidNow == '已退会') {
          this.navList[0].isShow = true;
          this.navList[1].isShow = true;
          this.navList[2].isShow = false;
          this.navList[3].isShow = false;
          this.navList[4].isShow = true;
          this.navList[5].isShow = false;
          this.navList[6].isShow = false;
          this.navList[7].isShow = false;
          this.navList[8].isShow = true;
        }
      }
    });


    this.$axios({
      method: 'post',
      url: 'newsmessage/ifnotread',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 1) {
        this.show = true;
      }
    });
    this.$axios({
      method: 'post',
      url: 'company/topaymentpage',
      data: Qs.stringify(data1)
    }).then(response => {
      if (response.data.state == 52) {
        this.$message({
          showClose: true,
          message: response.data.msg
        });
      }
    });

    if (sessionStorage.getItem('type') == 3) {
      if (sessionStorage.getItem('reset')) {
        if (sessionStorage.getItem('reset') == 1) {
          if (!sessionStorage.getItem('reset2')) {
            sessionStorage.setItem('reset2', 2);
            this.$confirm('默认密码登录， 请及时修改密码！并前往重要信息变更菜单更新完善部门联系人、电话、邮箱等信息。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.tabNav(4)
            }).catch(() => {

            });
          }

        }
      };
    } else if (sessionStorage.getItem('type') == 2) {
      if (sessionStorage.getItem('reset')) {
        if (sessionStorage.getItem('reset') == 1) {
          if (!sessionStorage.getItem('reset2')) {
            sessionStorage.setItem('reset2', 2);
            this.$confirm('默认密码登录， 请及时修改密码！并前往重要信息变更菜单更新完善部门联系人、电话、邮箱等信息。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.tabNav(3)
            }).catch(() => {

            });
          }

        }
      };
    }

  },
  methods: {
    qrcode () {
      var host = window.location.host;
      if (host.indexOf('caq.org') > 0) {
        var url = 'https://api.caq.org.cn/user/qrcode?number=' + this.bh;
      } else {
        var url = 'https://xiehui_api.buslive.cn/user/qrcode?number=' + this.bh;
      }
      let qrcode = new QRCode('qrcode', {
        width: 70,
        height: 70, // 高度  [图片上传失败...(image-9ad77b-1525851843730)]          
        text: url // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）  
        // background: '#f0f'  
        // foreground: '#ff0'  
      })
    },
    out () {
      if (sessionStorage.getItem('Token')) {
        var token = sessionStorage.getItem('Token');
      };
      var data1 = {
        'access-token': token
      };
      this.$axios({
        method: 'post',
        url: 'user/logout',
        data: Qs.stringify(data1)
      }).then(response => {
        if (response.data.state == 1) {
          //						sessionStorage.removeItem('Token');
          //						localStorage.removeItem('sessionid');
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push('/login');
        } else {
          this.$toast(response.data.msg);
        }
      })
    },
    cancel () {
      this.tc = false;
    },
    to_wanshan () {
      this.tc = false;
      this.isActive = 6;
    },
    to_msg () {
      this.isActive = -1
      sessionStorage.setItem('isActive', -1);
    },
    changePageType (number) {
      this.pageType = number
    },
    tabNav (i) {
      this.pageType = 1
      this.isActive = i
      sessionStorage.setItem('isActive', i);
    }
  }
}
</script>
<style scoped>
.out {
  height: 40px;
  line-height: 40px;
  color: #808080;
  float: right;
  font-weight: bold;
  cursor: pointer;
}

.index {
  width: 100%;
  height: auto;
  background: #fff;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #404040;
  text-align: left;
}

.banner {
  width: 1196px;
  height: 80px;
  position: relative;
  margin: 0 auto;
}

.logo {
  width: 211px;
  height: 42px;
  position: absolute;
  top: 16px;
  left: 0;
}

.banner h5 {
  position: absolute;
  top: 26px;
  left: 227px;
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(0, 94, 179, 1);
  line-height: 28px;
}

.banner h5 span {
  height: 17px;
  color: #e8e8e8;
}

#qrcode {
  width: 70px;
  height: 70px;
  position: absolute;
  right: 530px;
  top: 5px;
}

.user_msg {
  width: 490px;
  padding-top: 22px;
  height: 40px;
  position: absolute;
  top: 0;
  right: 0;
}

.warn {
  cursor: pointer;
  position: relative;
  height: 25px;
  line-height: 25px;
  float: left;
  color: #7d7d7d;
  padding-left: 33px;
  background: url(../../static/img/ling.png) no-repeat top left;
  background-size: 24px 25px;
}

.warn .dian {
  width: 4px;
  height: 4px;
  background: #ff4242;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 20px;
}

.warn_word {
  text-align: center;
  width: 215px;
  height: 47px;
  background: rgba(255, 251, 207, 1);
  border-radius: 4px 0px 0px 0px;
  border: 1px solid rgba(255, 229, 122, 1);
  line-height: 47px;
  color: #e47900;
  position: absolute;
  left: -70px;
  bottom: -50px;
}

.warn_word span {
  position: absolute;
  top: -12px;
  left: 90px;
  width: 0;
  height: 0;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  border-bottom: 12px solid rgba(255, 245, 204, 1);
}

.user_msg img {
  float: left;
  width: 40px;
  height: 35px;
  margin: 0 15px 0 31px;
}

.user_msg div {
  padding-right: 20px;
  text-align: left;
  float: left;
  width: 290px;
  height: 100%;
}

.user_msg div p {
  font-size: 12px;
  color: #bfbfbf;
}

.center {
  width: 100%;
  height: auto;
  padding-bottom: 35px;
  background-image: linear-gradient(#389df9, #1d4fa8);
}

.shade {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}

.tc {
  width: 384px;
  height: 185px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 16px 24px;
  box-sizing: border-box;
  text-align: center;
}

.tc_tit {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  height: 20px;
  line-height: 20px;
  margin-bottom: 20px;
}

.closed {
  width: 14px;
  height: 14px;
  background: url(../../static/img/close.png) no-repeat;
  background-size: 100%;
  position: absolute;
  right: 0;
  top: 3px;
}

.tc div {
  position: absolute;
  bottom: 35px;
  left: 0;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 80px;
  height: 24px;
}

.tc div span {
  cursor: pointer;
  line-height: 22px;
  color: #fff;
  float: left;
  width: 72px;
  height: 24px;
  background: rgba(24, 144, 255, 1);
  border-radius: 4px;
}

.tc .to_wanshan {
  float: right;
}

.center_box {
  width: 1232px;
  padding-top: 49px;
  margin: 0 auto;
  overflow: hidden;
}

.nav {
  padding-top: 16px;
  box-sizing: border-box;
  position: relative;
  float: left;
  width: 220px;
  height: 652px;
  overflow: hidden;
  background: #fff;
}
.img_box {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 125px;
  background: #daecff;
}
.img_box img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
  height: 75%;
}
.nav li {
  margin: 0 auto 20px;
  cursor: pointer;
  position: relative;
  width: 90%;
  height: 34px;
  line-height: 30px;
  box-sizing: border-box;
  font-size: 14px;
  border: 2px solid rgba(184, 221, 255, 1);
  border-radius: 3px;
}
.index .blue {
  box-shadow: 0px -1px 3px 0px rgba(187, 222, 255, 1);
  border: 2px solid rgba(87, 173, 255, 1);
}
.nav li a {
  color: #404040;
}
.nav li:hover {
  box-shadow: 0px -1px 3px 0px rgba(187, 222, 255, 1);
  border: 2px solid rgba(87, 173, 255, 1);
}

.nav li:nth-of-type(1) {
  background: url(../../static/img/icon20.png) no-repeat top 6px left 30px;
  background-size: 20px 18px;
  padding-left: 60px;
}

.nav li:nth-of-type(2) {
  background: url(../../static/img/icon21.png) no-repeat top 6px left 31px;
  background-size: 19px 19px;
  padding-left: 60px;
}

.nav li:nth-of-type(3) {
  background: url(../../static/img/icon22.png) no-repeat top 6px left 30px;
  background-size: 21px 20px;
  padding-left: 60px;
}

.nav li:nth-of-type(4) {
  background: url(../../static/img/icon23.png) no-repeat top 7px left 30px;
  background-size: 20px 15px;
  padding-left: 60px;
}

.nav li:nth-of-type(5) {
  background: url(../../static/img/icon23.png) no-repeat top 7px left 30px;
  background-size: 20px 15px;
  padding-left: 60px;
}

.nav li:nth-of-type(6) {
  background: url(../../static/img/icon24.png) no-repeat top 6.2px left 32px;
  background-size: 17px 18px;
  padding-left: 60px;
}

.nav li:nth-of-type(7) {
  background: url(../../static/img/icon27.png) no-repeat top 6px left 33px;
  background-size: 17px 19px;
  padding-left: 60px;
}

.nav li:nth-of-type(8) {
  background: url(../../static/img/icon25.png) no-repeat top 7px left 30px;
  background-size: 22px 15px;
  padding-left: 60px;
}

.nav li:nth-of-type(9) {
  background: url(../../static/img/icon26.png) no-repeat top 6px left 33px;
  background-size: 16px 18px;
  padding-left: 60px;
}

.nav li span {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 59px;
  height: 1px;
  background: #e1e4e5;
}

.con {
  padding-top: 9px;
  float: right;
  width: 988px;
  height: auto;
  position: relative;
  overflow: hidden;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue